<template>
  <b-row no-gutters>
    <b-col class="banner">
      <p class="text-primary font-weight-bold mb-0">
        {{ $t('registerBanner.previouslyRegisteredPet') }}
      </p>
      <p class="mb-0 text-dark">
        {{ $t('registerBanner.havePreviouslyRegisteredPet') }}
        <br />
        <b-link :href="renewLink" class="text-decoration-underline">{{ $t('registerBanner.fetchMyRecord') }}</b-link>
      </p>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'RegisterBanner',
  computed: {
    renewLink() {
      const redirect_path = this.$router.currentRoute?.query?.redirect_path;
      return `${window.BASE_URL}/activate${redirect_path ? `?redirect_path=` + redirect_path : ''}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@docupet/component-library/src/assets/styles/_variables';
.banner {
  padding: 19px;
  background-color: $dp-light-yellow;
  text-align: center;
}
</style>
